import React from 'react'
import {useTranslation} from 'react-i18next'

import {BaseSwitchInput} from './BaseSwitchInput'

type CanLargerPumpFitInputProps = Omit<
  React.ComponentProps<typeof BaseSwitchInput>,
  'title' | 'testId'
>

export const CanLargerPumpFitInput: React.FC<CanLargerPumpFitInputProps> = (props) => {
  const {t} = useTranslation()

  return (
    <BaseSwitchInput
      title={t(
        'orderIntake.rmc.steps.unloading.pumpConfiguration.canLargerPumpFit',
        'Can a larger pump fit?'
      )}
      testId="larger-pump-switch"
      {...props}
    />
  )
}
